import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import loadNamespaces from 'next-translate/loadNamespaces';
import DemoUpload from '../components/UploadLanding/DemoUpload';
import { Col, Row } from '../VuexyDesign/atoms/_index';
import { TextBold28, TextRegular16 } from '../VuexyDesign/atoms/Text';
import { useCurrentUser } from '../api';
import ReleaseTrackUpload from '../components/UploadLanding/ReleaseTrackUpload';
import YourMusicIsSafe from '../components/UploadLanding/YourMusicIsSafe';
import { useIsDesktop } from '../style/constants';
import BrowserPageTitle from '../components/common/BrowserPageTitle';
import { VirpPageContext } from './_app';

const UploadLanding = () => {
  const user = useCurrentUser();
  const { display_name } = user;
  const isDesktop = useIsDesktop();
  const { t } = useTranslation('upload');
  return (
    <Col className="d-flex w-100 justify-content-center">
      <BrowserPageTitle description={t('upload:browserPageTitle') as string}>
        {t('upload:browserPageDescription') as string}
      </BrowserPageTitle>
      <Row
        className={`d-flex flex-column align-items-center ${
          isDesktop ? 'w-75' : 'w-100'
        }`}
      >
        <div
          className={`d-flex flex-column mt-3 mb-2 ${
            isDesktop ? 'w-50 ' : 'w-100'
          }`}
        >
          <TextBold28 className="text-center">
            {t('upload:hiUser', { display_name }) as string}
          </TextBold28>
          <TextRegular16 className="text-center">
            {t('upload:areYouReady') as string}
          </TextRegular16>
        </div>
        <Row className="d-flex flex-column align-items-center">
          <Col md={11}>
            <div
              className={`d-flex justify-content-between ${
                isDesktop ? '' : 'flex-column'
              }`}
            >
              <div className={`${isDesktop ? 'w-50' : ''}`}>
                <DemoUpload />
              </div>
              <div className={`${isDesktop ? 'w-50' : 'mt-3'}`}>
                <ReleaseTrackUpload />
              </div>
            </div>
            <YourMusicIsSafe />
          </Col>
        </Row>
      </Row>
    </Col>
  );
};

UploadLanding.getInitialProps = async (ctx: VirpPageContext) => {
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/upload-landing',
  });
  return { ...getTranslations };
};

export default UploadLanding;
